module.exports = new __parcel__URL__("select-gitlab-csv.f84573a9.svg").toString();